// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2ofZx","error":"Select_error__2KsDv"};